export const initWishlistCallback = (widgetSelector) => {
  const swymCallback = (swat) => {
    document.addEventListener('swym:products-loaded', () => {
      swat.initializeActionButtons(widgetSelector);
    });
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCallback);
};
